import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'storageFormat'
})
export class StorageFormatPipe implements PipeTransform {
  transform(kbytes: number): string {
    const MB = 1024;
    const GB = MB * 1024;
    const TB = GB * 1024;

    if (kbytes >= TB) {
      return (kbytes / TB).toFixed(2) + ' TB';
    } else if (kbytes >= GB) {
      return (kbytes / GB).toFixed(2) + ' GB';
    } else if (kbytes >= MB) {
      return (kbytes / MB).toFixed(2) + ' MB';
    } else {
      return kbytes.toFixed(0) + ' KB';
    }
  }
}
